/* unplugin-vue-components disabled */import script from "./ForgetPasswordStep1Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetPasswordStep1Popup.vue?vue&type=script&setup=true&lang=js"

import "./ForgetPasswordStep1Popup.vue?vue&type=style&index=0&id=429671ca&lang=scss"

const __exports__ = script;

export default __exports__